<template>
  <div class="s-listbox" :class="{ [`s-listbox--size-${size}`]: true }">
    <ul class="s-listbox__options" v-bind="container.props">
      <SOption
        v-for="item in items"
        :key="item.key"
        v-bind="item.props"
        v-on="item.on"
      />
    </ul>
    <slot name="footer" />
  </div>
</template>

<script setup lang="ts">
import type { UseListboxEmit } from "@/lib/components/logic/atoms/useListbox";

import SOption from "@/lib/components/atoms/option/SOption.vue";
import * as useListbox from "@/lib/components/logic/atoms/useListbox";

const props = defineProps(useListbox.props);
const emit = defineEmits<UseListboxEmit>();

const { container, items, size } = useListbox.use(props, emit);
</script>

<style lang="postcss">
.s-listbox {
  @apply absolute left-0 top-0 z-20 flex flex-col overflow-hidden rounded-lg bg-white shadow-lg;

  &__options {
    @apply m-0 flex max-h-96 list-none flex-col overflow-auto p-0;
    scroll-behavior: smooth;
  }

  &--size {
    &-lg .s-listbox__options {
      @apply max-h-112;
    }

    &-md .s-listbox__options {
      @apply max-h-96;
    }

    &-sm .s-listbox__options {
      @apply max-h-80;
    }
  }
}
</style>
